import IconHome from '@/icons/home.svg'
import {MainMenuItemModel} from "@/components/custom/header/mainmenu/mainMenuItem";
import {Stack} from "@/lib/utils";

interface MobileBreadcrumbProps {
    itemStack: Stack<MainMenuItemModel[]>
    history: MainMenuItemModel[][];
    setHistory: Function;
    lastSelectedItems: MainMenuItemModel[];
    setLastSelectedItems: Function;
}

const MobileBreadcrumb = ({ itemStack, history, setHistory, lastSelectedItems, setLastSelectedItems }: MobileBreadcrumbProps) => {

    const handleBreadcrumbClick = (index: number) => {
        setHistory(history.slice(0, index + 1));
        setLastSelectedItems(lastSelectedItems.slice(0, index))
        while (itemStack.size() > index) {
            itemStack.pop();
        }
    };

    return (
        <ul className='border-b-gray-beige-dark/50 flex list-none flex-row items-center border-b px-8 py-3 text-xs text-gray-beige-dark'>
            {history.map((items, index) => (
                <li key={index} className={"flex-row items-center"}>
                    {index === 0 ?
                        <div
                            className='inline-flex cursor-pointer flex-row items-center text-gray-beige-dark hover:text-primary'>
                                <span onClick={() => handleBreadcrumbClick(index)} className='mr-1 h-3 w-3'>
                                    <IconHome className='h-3 w-3'/>
                                </span>
                        </div> :
                        <div
                            className='inline-flex cursor-pointer flex-row items-center text-gray-beige-dark hover:text-primary before:ml-1 before:mr-1 before:content-["/"]'>
                            {<span onClick={_ => handleBreadcrumbClick(index)}
                                   className='label'>{history[index - 1].find(i => i.children === items)?.text}
                                  </span>}
                        </div>
                    }
                </li>
            ))}
        </ul>
    )
}

export {MobileBreadcrumb}
